export default "__VITE_ASSET__8980e1ed__"